import 'arrive';

// Import Swiper bundle (include tutti i moduli)
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.arrive('.single-product-gallery', { existing: true }, function () {
    const galleryContainer = document.querySelector('.single-product-gallery');
    
    if (!galleryContainer) {
        return;
    }

    const mainSwiper = galleryContainer.querySelector('.swiper-main');
    const imagesCount = parseInt(galleryContainer.dataset.imagesCount) || 0;

    if (!mainSwiper || imagesCount === 0) {
        return;
    }

    const swiperMain = new Swiper(mainSwiper, {
        slidesPerView: 1.2,
        spaceBetween: 8,
        centeredSlides: false,
        loop: true,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragSize: 'auto',
        },
        breakpoints: {
            500: {
                slidesPerView: 1.2,
                spaceBetween: 8,
            },
            768: {
                slidesPerView: 1.5,
                spaceBetween: 24,
            },
            992: {
                slidesPerView: 1.7,
                spaceBetween: 24,
            }
        }
    });

    // Aggiungi navigazione con zone invisibili (solo desktop)
    const prevZone = galleryContainer.querySelector('.gallery-nav-zone--prev');
    const nextZone = galleryContainer.querySelector('.gallery-nav-zone--next');

    if (prevZone && nextZone && window.innerWidth > 767) {
        prevZone.addEventListener('click', () => {
            swiperMain.slidePrev();
        });

        nextZone.addEventListener('click', () => {
            swiperMain.slideNext();
        });

        // Rimuovi event listener su resize se diventa mobile
        window.addEventListener('resize', () => {
            if (window.innerWidth <= 767) {
                prevZone.style.pointerEvents = 'none';
                nextZone.style.pointerEvents = 'none';
            } else {
                prevZone.style.pointerEvents = 'auto';
                nextZone.style.pointerEvents = 'auto';
            }
        });
    }

    console.log('Product gallery initialized with', imagesCount, 'images');
});
